<app-action-button-with-embedded-spinner [actionObservable]="updateInstanceStatistic.bind(this)" [icon]="'replay'"
    [hint]="'Update Instance Statistic'"></app-action-button-with-embedded-spinner>
